import dayjs from 'dayjs';

export function getPartialData<T extends object>(
  origin: T,
  keyList: (keyof T)[]
) {
  return keyList.reduce((acc: Partial<T>, cur) => {
    acc[cur] = origin[cur];
    return acc;
  }, {}) as Pick<T, (typeof keyList)[number]>;
}

export const framerBottomSheetDimVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 0.4 },
  exit: { opacity: 0 },
  transition: {
    duration: 0.35,
    ease: [ 0.32, 1, 0.23, 1 ],
  },
};

export const framerBottomSheetContentVariants = {
  initial: { y: '100%' },
  animate: { y: 0 },
  exit: { y: '100%' },
  transition: {
    duration: 0.44,
    ease: [ 0.32, 1, 0.23, 1 ],
    delay: 0.08,
  },
};

export const framerModalDimVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

export const framerModalContentVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

export function generateMappedArray(targetNumber: number): number[] | null {
  const number = Math.floor(targetNumber);

  if (number === 0 || number === 1) {
    return null;
  } else if (number > 1) {
    const mappedArray: number[] = [];
    const length = Math.ceil(number);
    for (let i = 0; i < length; i++) {
      const value = i / (length - 1);
      mappedArray.push(Number(value.toFixed(2)));
    }
    return mappedArray;
  } else {
    return null;
  }
}

export function toKRWFormat(price: number, locale = 'ko', type?: 'pre' | 'post' | 'plain'): string {
  const priceToLocale = price.toLocaleString();
  if (type === 'plain') return priceToLocale;
  if(locale === 'ko') return `${priceToLocale}원`;
  return type === 'post' ? `${priceToLocale} won` : `₩${priceToLocale}`;
}

export function getCDNImage(url: string, { width, height }: { width?: number, height?: number }): string {
  if (window.devicePixelRatio == null) return url;
  if (!width && !height) return url;
  
  const dpr = Math.ceil(window.devicePixelRatio);
  const params = new URLSearchParams();

  if (width) params.append('width', `${width * dpr}`);
  if (height) params.append('height', `${height * dpr}`);

  return `${url}?${params.toString()}`;
}

export interface ConditionProps {
  type: 'until' | 'from'; // until: ~~까지 적용, from: ~~부터 적용
  targetDate: string; // (YYYY-MM-DD HH:mm:ss) 형식으로 전달
}

export function getConditionByDuration({ targetDate, type }: ConditionProps): boolean {
  const now = dayjs(); // 현재 시간
  const target = dayjs(targetDate); // 대상 시간

  // type이 until이면 현재 시간이 대상 시간보다 이전이면 true, 이후이면 false
  if (type === 'until') return now.isBefore(target);
  // type이 from이면 현재 시간이 대상 시간보다 이후이면 true, 이전이면 false
  return now.isAfter(target);
}

export function normalizeHexColor(hex: string) {
  return hex.length === 4 ? `#${hex.slice(1).split('').map(c => c + c).join('')}` : hex;
}
